// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1NDbl7PPTqHmYLFubwH4zx {\n    font-weight: 100;\n}\n\n._1boBJy2MFQRSDw-jjmhel7 {\n    font-weight: 600;\n}\n\n.H4k7j90fxuI0iqe9XU8dR {\n    font-weight: bold;\n}\n\n.w1k_bxoYEqrC63SdMGsp2 {\n    font-style: italic;\n    font-weight: 100;\n}\n", ""]);
// Exports
exports.locals = {
	"light": "_1NDbl7PPTqHmYLFubwH4zx",
	"emphasis": "_1boBJy2MFQRSDw-jjmhel7",
	"heavy": "H4k7j90fxuI0iqe9XU8dR",
	"note": "w1k_bxoYEqrC63SdMGsp2"
};
module.exports = exports;
